(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["miffy-campaign"] && !Shopify.designMode) return;
  try {
    
    (function () {
        function initMiffyCampaign(root) {
            if (!root || root.classList.contains('is-visible')) return;

            if (!('IntersectionObserver' in window)) {
                root.classList.add('is-visible');
                return;
            }

            var observer = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            root.classList.add('is-visible');
                            observer.disconnect();
                        }
                    });
                },
                { threshold: 0.5 },
            );

            observer.observe(root);
        }

        function initAll(scope) {
            (scope || document)
                .querySelectorAll('.miffy-campaign')
                .forEach(initMiffyCampaign);
        }

        initAll();

        document.addEventListener('shopify:section:load', function (event) {
            initAll(event.target);
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendation"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        


        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;

        fetch(url).then((response) => response.text()).then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;

                window.ProductItem.init();
            }
        }).catch((e) => {
            console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

    observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
